export function getButtonType(_props) {
  // I wasn't able to get TS to play ball here, so I had to use unknown and a type assertion
  var props = _props;
  var type = undefined;
  if ("type" in props) {
    // If a type is explicitly provided we use that
    type = props.type;
  } else if ("href" in props && props.href || props["aria-disabled"] === "true") {
    // It's most likely a link so we don't add type="button"
  } else {
    // It is most likely a button so we add type="button"
    type = "button";
  }
  return type;
}